import {Condition} from "../engine/Condition";
import {userDataModule} from "../../UserDataModule";

export const USER_DATA_CONDITIONS = {
    isAuthenticated: "isAuthenticated",
    isSubscriber: "isSubscriber",
    isDonor: "isDonor",
};

export class UserDataCondition extends Condition {
    constructor(...args) {
        super(...args);

        this.attachListener(userDataModule.userPreferencesChange, this.requestReEval);
    }

    evaluate() {
        switch (this.options.type) {
            case USER_DATA_CONDITIONS.isAuthenticated: return userDataModule.isAuthenticated();

            // TODO: Probably want more control over recurring donor status, time
            //  since last donation, donation amount etc.
            case USER_DATA_CONDITIONS.isDonor: return !!userDataModule.isDonor();

            // TODO: Probably want options for filtering offers, coverage etc.
            case USER_DATA_CONDITIONS.isSubscriber: return !!userDataModule.isSubscriber();

            default:
                return false;
        }
    }
}
